import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { TokenAtom } from "../Hooks/TokenAtom"; // 올바른 import


const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await fetch(`/api/Refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    if (!response.ok) {
      throw new Error("Failed to refresh token");
    }

    const data = await response.json();
    return data.access; // 새로 받은 access token 반환
  } catch (error) {
    console.error("Error refreshing access token:", error);
    return null;
  }
};

const AuthHandler = () => {
  const [tokens, setTokens] = useRecoilState(TokenAtom);

  useEffect(() => {
    if (!tokens.refresh) return; // Refresh token이 없으면 아무것도 하지 않음

    // 함수 내부에서 interval ID를 저장합니다.
    const intervalId = setInterval(async () => {
      const newAccessToken = await refreshAccessToken(tokens.refresh);

      if (newAccessToken) {
        setTokens((prevTokens) => ({
          ...prevTokens,
          access: newAccessToken,
        }));
      } else {
        // 토큰이 없거나 갱신 실패 시, 로그인 페이지로 리디렉션
        setTokens({ access: undefined, refresh: undefined });
        // 여기에 리디렉션 로직 추가 가능
      }
    }, 30 * 60 * 1000); // 30분마다 갱신

    // 컴포넌트 언마운트 시 interval을 클리어합니다.
    return () => clearInterval(intervalId);
  }, [tokens, setTokens]);

  return null; // 이 컴포넌트는 UI를 렌더링하지 않음
};

export default AuthHandler;
